import React from "react";
import CustomText from "@components/CustomText";

// Wrapper around the shared @components/CustomText, used by every dark store
// screen and ds component instead of importing CustomText directly.
//
// Hindi labels inside this screen's compact pills (tabs, chips, CTA
// buttons) were losing their tail word/glyphs on the Android staging
// build — e.g. "रैक करें" painting as just "रैक". Removing stray
// `fontWeight` overrides stacked on top of CustomText's own per-variant
// font file (that combination makes Android fake-bold an already-weighted
// Devanagari typeface) fixed most instances; these three props close the
// rest of the gap without changing the shared, app-wide CustomText.js:
//   - textBreakStrategy="simple": skips Android's ICU-based line breaker,
//     which is the layer implicated in the text-layout-cache class of bug
//     this looked like (identical container bounds, differing painted
//     content between renders).
//   - includeFontPadding={false}: removes Android's extra font metrics
//     padding, which can clip a custom font's tall Devanagari matras.
//   - allowFontScaling={false}: this feature's copy is tuned to fixed-size
//     pills/chips; keeps it consistent with the design mock regardless of
//     the CP's device font-scale setting.
const DsText = (props) => (
  <CustomText
    textBreakStrategy="simple"
    includeFontPadding={false}
    allowFontScaling={false}
    {...props}
  />
);

export default DsText;
